var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUzcard = function SvgUzcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 32,
    fill: "#27272A",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#uzcard_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6 16.365c0 2.468-.564 4.307-1.691 5.505q-1.693 1.797-5.215 1.797-3.291 0-4.992-1.797T23 16.45V8.343c0-.19.154-.343.344-.344h3.977c.19 0 .343.154.344.344v8.282q-.001 1.48.554 2.281a2.01 2.01 0 0 0 3.172.048q.545-.754.543-2.222v-1.55H36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.24 14.277h-4.305V8.36c0-.199.162-.36.36-.36h.645a3.66 3.66 0 0 0 3.659 3.657h.001v2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.857 8h2.383c.198.001.36.162.36.36v2.387a2.744 2.744 0 0 1-2.744-2.744z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uzcard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 8h13.6v16H23z"
  })))));
};
export default SvgUzcard;